// @flow

const TELETHERAPY_STATE_KEY = 'teleTherapyState';

export const teletherapyPersistence = store => next => action => {
  const result = next(action);
  const state = store.getState();

  switch (action.type) {
    case 'SET_CLUSTER_SESSION_DATA':
    case 'SET_CHIME_SESSION_DATA':
    case 'SET_ATTENDEES':
      
    // eslint-disable-next-line no-fallthrough
    case 'SET_JOIN_DATA': {

      const teleTherapyState = {
        teleTherapySessionData: state.teleTherapy.teleTherapySessionData,
        chime_data: state.teleTherapy.chime_data,
        attendees: state.teleTherapy.attendees,
        joinData: state.teleTherapy.joinData,
      };

      sessionStorage.setItem(TELETHERAPY_STATE_KEY, JSON.stringify(teleTherapyState));
      break;
    }

    case 'CLEAR_SESSION': {
      sessionStorage.removeItem(TELETHERAPY_STATE_KEY);
      break;
    }

    default: 
    
      break;
  }

  return result;
};

export const rehydrateTeletherapyState = (store) => {
  try {
    const persistedStateJSON = sessionStorage.getItem(TELETHERAPY_STATE_KEY);

    if (persistedStateJSON) {
      const persistedState = JSON.parse(persistedStateJSON);

      store.dispatch({ type: 'SET_CLUSTER_SESSION_DATA', teleTherapySessionData: persistedState.teleTherapySessionData });
      store.dispatch({ type: 'SET_CHIME_SESSION_DATA', chime_data: persistedState.chime_data });
      store.dispatch({ type: 'SET_ATTENDEES', attendees: persistedState.attendees });
      store.dispatch({ type: 'SET_JOIN_DATA', joinData: persistedState.joinData });
    }
  } catch (e) {
    console.error('Could not rehydrate teletherapy state', e);
  }
};
